import styled from "styled-components";
import { mediaMaxWidth } from "../../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  height: calc(100% - 40px);

  ${mediaMaxWidth.phone`
    padding: 0;
  `}

  .animated {
    animation-duration: 0.25s;
    animation-fill-mode: both;
  }

  .delay-1 {
    animation-delay: 0.1s;
  }

  .delay-2 {
    animation-delay: 0.2s;
  }

  .delay-3 {
    animation-delay: 0.3s;
  }

  .delay-4 {
    animation-delay: 0.4s;
  }

  .delay-5 {
    animation-delay: 0.5s;
  }

  .delay-6 {
    animation-delay: 0.6s;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInUp {
    animation-name: fadeInUp;
  }

  @keyframes bounceIn {
    from,
    20%,
    40%,
    60%,
    80%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    20% {
      transform: scale3d(1.1, 1.1, 1.1);
    }

    40% {
      transform: scale3d(0.9, 0.9, 0.9);
    }

    60% {
      opacity: 1;
      transform: scale3d(1.03, 1.03, 1.03);
    }

    80% {
      transform: scale3d(0.97, 0.97, 0.97);
    }

    to {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
  }

  .bounceIn {
    animation-duration: 0.75s;
    animation-name: bounceIn;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInDown {
    animation-name: fadeInDown;
  }
`;

export const Form = styled.form`
  width: 500px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.decline && "space-evenly"};

  ${mediaMaxWidth.tablet`
    width: 400px;
  `}

  ${mediaMaxWidth.phone`
    width: 85vw;
  `}
`;

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;
  margin-bottom: 20px;

  span {
    font-weight: 700;
  }

  ${mediaMaxWidth.phone`
    font-size: 0.85em;
  `}

  ${mediaMaxWidth.smallPhone`
    margin-bottom: 10px;
    font-size: 0.8em;
  `}
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  width: 100%;
  resize: none;
  height: 10em;
  padding: 10px;
  position: relative;
  margin: 20px 0;

  ::placeholder {
    opacity: 0.75;
    font-weight: 300;
    font-style: italic;
  }

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  ${mediaMaxWidth.phone`
    height: 7em;
    padding: 10px;
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 5px 10px;
  }

  ${mediaMaxWidth.phone`
    justify-content: space-between;

    button {
      margin: 0;
    }
  `}

  ${mediaMaxWidth.smallPhone`
    button {
      font-size: 0.85em;
      padding: 7px 10px;
    }
  `}
`;

export const Field = styled.div`
  position: relative;

  .__react_component_tooltip {
    margin-left: 0;

    ${mediaMaxWidth.phone`
      display: none;
    `}
  }
`;

export const Filename = styled.div`
  max-width: 380px;
  position: absolute;
  top: 15px;
  left: 50px;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  text-overflow: ellipsis;
  transition: 0.1s ease-in-out;
  pointer-events: none;
  position: absolute;
  color: #fff;

  span {
    font-weight: 300;
    margin-left: 5px;
  }

  ${mediaMaxWidth.tablet`
    max-width: 300px;
  `}

  ${mediaMaxWidth.phone`
    max-width: calc(100vw - 150px);
    font-size: 0.85em;
    top: 17px;
    left: 46px;
  `}

  ${mediaMaxWidth.smallPhone`
    max-width: calc(100vw - 140px);
  `}
`;

export const FileInputLabel = styled.label`
  cursor: pointer;
  width: 100%;
  background-color: ${(props) => (props.fileAttached ? "#27AE60" : "#b8b8b8")};
  padding: 10px 15px;
  border-radius: 4px;
  font-size: 1.4em;
  margin-bottom: 20px;
  transition: 0.1s ease-in-out;
  color: #fff;

  &:hover {
    background-color: ${(props) =>
      props.fileAttached ? "#27AE60" : "#79D9D9"};
  }

  ${mediaMaxWidth.phone`
    margin-bottom: 20px;
  `}

  ${mediaMaxWidth.smallPhone`
    margin-bottom: 10px;
  `}
`;

export const FileInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;

  & + ${FileInputLabel} {
    font-size: 1.25em;
    font-weight: 700;
    color: white;
    background-color: black;
    display: inline-block;
  }
`;

export const RemoveAttachment = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 1.4em;
  padding: 10px 15px;
  color: #fff;
  cursor: pointer;
  z-index: 2;
`;

export const Error = styled.div`
  font-size: 0.75em;
  width: 100%;

  color: #79D9D9;
  font-weight: 600;

  ${mediaMaxWidth.smallPhone`
    font-size: 0.7em;
  `}
`;
